import React from "react";

function About() {
    return <div id="about" className="aboutUsDiv">
        <h1>About Us</h1>
        <hr />
        <p>
            Welcome to the Mastering Machine Learning presented by IIIT Bhopal! We are thrilled to introduce ourselves, the dedicated team behind this exciting gathering of machine learning enthusiasts, thought leaders, and innovators.
        </p>
        <p>
        Driven by our commitment to the advancement of knowledge, we draw inspiration from the rapidly evolving landscape of machine learning. Our fascination with the limitless potential of AI drives us to curate events that not only educate but also inspire and connect like-minded individuals.
        We invite you to be a part of this incredible journey into the world of machine learning. Whether you're a seasoned professional or just starting your AI journey.
        </p>
        <hr />
    </div>
}

export default About;